import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuthenticationService } from 'src/app/_services';
import { ApiService } from 'src/app/api.service';
import { TabService } from 'src/app/utils/TabService';
import { first } from 'rxjs/operators';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-recover-link',
  templateUrl: './recover-link.component.html',
  styleUrls: ['./recover-link.component.scss'],
  providers: [MessageService, ConfirmationService, TabService]
})
export class RecoverLinkComponent implements OnInit {

  // ENVIRONMENT 
  private SERVER_URL = environment.urlResponsive;

  // RECOVER FORM
  recoverLinkFrom: FormGroup;
  security: SecurityDocument;
  currentUser: any;
  selLang: string;
  linkResulted: string;
  guideName: string;

  // LANGUAGE
  lbl_recover_password: string = "recover_password_";
  lbl_email: string = "email_";
  lbl_certificate: string = "certificate_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_guide_id: string = "guideId_";
  lbl_request: string = "request_";
  lbl_go_Back: string = "back_";
  lbl_link: string = "link_";

  device: string;

  /**
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success messages, error messages, and warning messages.
   */


  constructor(
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private router: Router) {

    this.route.queryParams.subscribe(
      params => {
        this.device = params.device;
      });
    if (this.device) {
      if (this.device) {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
    }
  }

  ngOnInit(): void {

    // LANG
    this.route.queryParams
      .subscribe(
        params => {

          this.selLang = params.language;
        });

    // FORMS DECLARATIONS 
    this.recoverLinkFrom = this.formBuilder.group({
      "currentEmail": new FormControl("", [
        Validators.required,
        Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$"),
        Validators.maxLength(100),
        Validators.minLength(2),
      ]),
      "currentCertified": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(2),
      ]),
      "currentIdGuide": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(7),
        Validators.minLength(2),
      ]),
    });
  }

  confirmRecoverLink(event) {

    this.recoverLinkFrom.markAsUntouched();

    event.preventDefault();
    this.validateAllFormFields(this.recoverLinkFrom);

    // VALIDO PROCESA
    let body = {
      email: this.recoverLinkFrom.controls["currentEmail"].value,
      certificate: this.recoverLinkFrom.controls["currentCertified"].value,
      guideId: this.recoverLinkFrom.controls["currentIdGuide"].value,
      language: this.selLang
    }
    this.apiService.recoverLink(body).then(
      data => {
        if (data != null && data.status == 'OK') {
          this.linkResulted = this.SERVER_URL + 'electov/choose?welcomeID=' + data.passCode + data.shortName + '&group=' + (data.language != null ? data.language : 'es' + '_' + 'MX');
          this.guideName = data.guideName;
          this.resetForms();

          this.messageService.add({ key: 'tst', severity: 'success', summary: 'Verifique enlace abajo', detail: "verfique nombre del Guia", life: 7000 });

        } else {
          this.messageService.add({ key: 'tst', severity: 'error', summary: data.errorMessage, detail: ' ', life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Recupera Contraseña', detail: error, life: 3000 });
      });
  }
  resetForms() {
    this.recoverLinkFrom.reset();
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.currentUser = this.authenticationService.currentUserValue;
            this.getSecurity();
          }
        },
        error => {
          console.error(error);
        });
  }

  getSecurity() {
    this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
      data => {
        this.security = data;

        if (this.security) {

          this.getTranslatedLabels();

        }
      });
  }

  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.selLang != null ? this.selLang : window.navigator.language.split("-")[0],
      'region': this.security.region,
      'lstLabels': [this.lbl_recover_password, this.lbl_email, this.lbl_certificate, this.lbl_cell_phone, this.lbl_guide_id, this.lbl_request, this.lbl_go_Back, this.lbl_link]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_recover_password = map.get(this.lbl_recover_password);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_request = map.get(this.lbl_request);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_link = map.get(this.lbl_link);
      });
  }

  goBack() {
    window.close();
  }

  copyToClipBoard(value) {
    navigator.clipboard.writeText(value);
  }
}
